import { BaseTxRedeemer } from '../../Entities/index.exports';
import { Convertible } from '../index.exports';

export type DelegationPolicyRedeemer = DelegationPolicyRedeemerMintID | DelegationPolicyRedeemerBurnID;

export class DelegationPolicyRedeemerMintID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;
}

export class DelegationPolicyRedeemerBurnID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 2;
    protected static _plutusDataIsSubType = true;
}

export type DelegationValidatorRedeemer =
    | DelegationValidatorRedeemerUpdateMinADA
    | DelegationValidatorRedeemerDeposit
    | DelegationValidatorRedeemerWithdraw
    | DelegationValidatorRedeemerDelete;

export class DelegationValidatorRedeemerUpdateMinADA extends BaseTxRedeemer {
    protected static _plutusDataIndex = 0;
    protected static _plutusDataIsSubType = true;
}

export class DelegationValidatorRedeemerDeposit extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rdDelegated_TokenGov_Change!: bigint;
}

export class DelegationValidatorRedeemerWithdraw extends BaseTxRedeemer {
    protected static _plutusDataIndex = 2;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rwDelegated_TokenGov_Change!: bigint;
}

export class DelegationValidatorRedeemerDelete extends BaseTxRedeemer {
    protected static _plutusDataIndex = 3;
    protected static _plutusDataIsSubType = true;
}

export class DelegationValidatorRedeemerEmergency extends BaseTxRedeemer {
    protected static _plutusDataIndex = 4;
    protected static _plutusDataIsSubType = true;
}
